import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e56885a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-center mb-10" }
const _hoisted_2 = { class: "flex flex-col gap-20" }
const _hoisted_3 = {
  key: 0,
  class: "flex-col items-center justify-center locked align-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-10" }, "Bohemians are locked!", -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NFTGrid = _resolveComponent("NFTGrid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.bank && _ctx.vault)
        ? (_openBlock(), _createBlock(_component_NFTGrid, {
            key: 0,
            title: "Your vault",
            class: "flex-1",
            stake: "true",
            nfts: _ctx.desiredVaultNFTs,
            onStake: _ctx.handleUnstake,
            onSelected: _ctx.handleVaultSelected
          }, {
            default: _withCtx(() => [
              (_ctx.vaultLocked)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["nfts", "onStake", "onSelected"]))
        : _createCommentVNode("", true),
      _createVNode(_component_NFTGrid, {
        title: "Your wallet",
        class: "flex-1",
        stake: "false",
        onStake: _ctx.handleStake,
        nfts: _ctx.desiredWalletNFTs,
        onSelected: _ctx.handleWalletSelected
      }, null, 8, ["onStake", "nfts", "onSelected"])
    ])
  ], 64))
}